import { Component, HostBinding, OnInit } from '@angular/core';
import axios from 'src/app/Service/axios';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';

@Component({
  selector: 'company',
  templateUrl: './company.component.html',
})
export class ComponyComponent implements OnInit {
  constructor(private gurdService: GurdServiceService) {}
  htmlStr: string = 'AboutUs';
  ngOnInit(): void {
  this.getHtml();
  }
  getHtml= async () =>{
    const resp = await axios.post(`GetCompanyInfo?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}`, );
    this.htmlStr=resp.data;
    
  }
}
